import { useQuery } from '@tanstack/react-query';

import { useCommunicationApi } from '../../api';
import { communicationKeys } from '../../query-key-factory';
import { ConsumerNewsletter } from './newsletters.types';

const useShowConsumerNewsletter = ({ newsletterId }: { newsletterId?: string }) => {
  const CommunicationApi = useCommunicationApi();
  const get = async () => {
    const { data } = await CommunicationApi.get<{ newsletter: ConsumerNewsletter }>(
      `/consumer/newsletters/${newsletterId}`
    );
    return data.newsletter;
  };
  return useQuery({
    queryKey: newsletterId ? communicationKeys.consumer.newsletters.id(newsletterId).all : [],
    queryFn: get,
    enabled: !!newsletterId,
  });
};

export { useShowConsumerNewsletter };
